export const config = {
  googleAnalyticsKey: "G-GJH7Y0QXEE"
}